<template>
  <div class="top-nav container">
    <el-dialog :title="modelTilte" :visible.sync="modalVisible" :show-close="false">
      <component :is="currentModalComponent" @dismiss="modalVisible=false"></component>
    </el-dialog>
    <span class="logo">
    <!-- <img src="../../assets/logo.png" width="120">&nbsp;&nbsp; -->游利社后台管理
    </span>
    <div class="top-right">
      <el-dropdown>
        <span style="cursor:pointer;">
          <img style="border-radius: 6px;" src="https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80" alt="" width="30">
          <!-- <img src="../../assets/img/icon_photo.png" alt="" width="30" > -->
          <h4>管理员</h4>
        </span>
        <el-dropdown-menu slot="dropdown" style="top:48px !important;">
          <el-dropdown-item>
            <div @click="logout">退出登录</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </div>
  </div>
</template>
<script>
  export default {
    name: "top-nav",
    data() {
      return {
        isActive: true,
        menuItems: this.cache.fetchMenuItems(),
        currentModalComponent: "",
        modelTilte: "",
        modalVisible: false
      };
    },

    computed: {
      current() {
        return this.$store.state.layout.currentMenuKey;
      },
    },

    methods: {
      foldAction() {
        this.isActive = !this.isActive;
        this.$store.commit("changeHumberOpen", this.isActive);
      },

      logout() {
        this.$confirm('确定退出登录？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.ajax.fetch({
            url: this.apis.public.loginOut,
            successFunc: () => {
              this.cache.clearMenuItems();
              this.cache.clearMenuKey();
              this.$router.replace("/login");
            }
          })
        }).catch(() => {

        });
      }
    }
  }
</script>


<style lang="scss" type="text/scss" scoped>
  @import "../../style/public";
  .logo {
    display: flex;
    left: 20px;
    position: absolute;
    align-items: center;
    font-size: 26px;
    color: white;

  }

  .top-nav {
    height: 100%;
    background-color: $topLightColor;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .top-left {
    display: flex;
    align-items: center;
  }

  .top-right {
    position: absolute;
    right: 25px;
    display: flex;
    align-items: center;
    height: 48px;
    span {
      color: white;
      padding: 20px;
      display: flex;
      align-items: center;
      h4 {
        display: inline-block;
        margin-left: 4px;
      }
    }
  }

  .fold {
    display: flex;
    align-items: center;
    h2 {
      color: white;
      font-size: 18px;
      line-height: $topNavHeight;
      margin-left: 20px;
    }
    span {
      width: $topNavHeight;
      height: $topNavHeight;
      background-color: $topLightColor;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: $topDarkColor;
      }
    }
  }

  .hamburger {
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    transform: rotate(90deg);
    transition: .38s;
  }

  .hamburger.active {
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    transition: .38s;
  }

  .el-dropdown-menu {
    top: 42px !important;
  }

  a {
    display: flex;
    align-items: center;
    span {
      padding: 10px 4px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/top-nav.vue